<template>
  <base-picture
    v-if="images"
    v-bind="images"
    class="w-full"
    fit="cover"
  />
  <vf-video
    v-if="video"
    v-bind="video"
    autoplay
    class="w-full"
    fit="cover"
    loop
    muted
  />
</template>

<script lang="ts" setup>
import type { PlayerSettings } from '#types/components/cms/video-player'
import type { ResponsiveMedia } from '#types/content'

const { media } = defineProps<{
  media: ResponsiveMedia
  playerSettings?: PlayerSettings
}>()

const { getMedia } = useCms()

const { images, video } = (media && getMedia(media)) || {} as ResponsiveMedia
</script>
